var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"notification-delivery"},[_c('div',{staticClass:"notification-content"},[_c('i',{staticClass:"fas fa-shipping-fast icon"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('deliveryMessage')))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }